import React from 'react';
import { styles } from './styles';
import { withStyles, StyledComponentProps, Typography } from '@material-ui/core';
import { MenuSubscriptions } from '../../ui-components/Icons';

const subscriptions = (props: StyledComponentProps) => {
    return (<div className={props.classes.root}>
        <MenuSubscriptions  className={props.classes.subHeaderIcon}/>
        <Typography className={props.classes.title} variant='h6'>Abbonamenti</Typography>
    </div>)
}

export const Subscriptions = withStyles(styles)(subscriptions)